import type { ReactNode } from 'react';

interface SectionProps {
  // Optional: a header-less Section is just the card, used where the page
  // already names the section (e.g. the Modify page's breadcrumb).
  title?: string;
  description?: string;
  children: ReactNode;
}

export default function Section({ title, description, children }: SectionProps) {
  return (
    <section className="space-y-3">
      {(title || description) && (
        <div>
          {title && (
            <div className="text-[11px] font-medium text-muted-foreground uppercase tracking-wider">
              {title}
            </div>
          )}
          {description && (
            <p className="text-xs text-muted-foreground mt-0.5">{description}</p>
          )}
        </div>
      )}
      <div className="rounded-lg border bg-card p-4">{children}</div>
    </section>
  );
}
